export default "__VITE_ASSET__CE09bqfh__"